/**
 * Real API implementation for Location Cleaning Standards.
 */

import { apiClient } from '../apiClient';
import { normalizeServiceError } from '../../utils/serviceError';
import {
  validateLocationStandardsBody,
  validateDraftBody,
} from '../../utils/locationCleaningStandardsValidation';

const V3_CLEANING_STANDARDS_LOCATION = '/api/v3/cleaning-standards/location';
const V3_LOCATIONS_CLEANING_STANDARDS_COPY = '/api/v3/locations/cleaning-standards/copy';

const getLocationStandardsPath = (locationId) =>
  `${V3_CLEANING_STANDARDS_LOCATION}/${locationId}`;

export async function getLocationCleaningStandards(locationId) {
  try {
    const response = await apiClient.get(getLocationStandardsPath(locationId));
    return response.data;
  } catch (error) {
    if (error.response?.status === 404) return { success: true, data: null };
    throw normalizeServiceError(error);
  }
}

export async function putLocationCleaningStandards(locationId, body) {
  validateLocationStandardsBody(body);
  const { data } = await apiClient.put(
    getLocationStandardsPath(locationId),
    body,
  );
  return data;
}

export async function patchLocationCleaningStandardsDraft(locationId, body) {
  validateDraftBody(body);
  const { data } = await apiClient.patch(
    `${getLocationStandardsPath(locationId)}/draft`,
    body,
  );
  return data;
}

export async function copyLocationCleaningStandards(
  sourceLocationId,
  targetLocationIds,
) {
  const { data } = await apiClient.post(V3_LOCATIONS_CLEANING_STANDARDS_COPY, {
    sourceLocationId,
    targetLocationIds: targetLocationIds || [],
  });
  return data;
}
